import React, { useEffect, useState } from 'react';
import { showMessage } from 'react-native-flash-message';
import FlashMessage from 'react-native-flash-message';
import { useCssStyle } from '../../customHook/getCssStyle';
import { NativeModules, Platform, StatusBar } from 'react-native';
import { useDispatch } from 'react-redux';
import { setRenderFlashMessage } from '../../Redux/Actions/appConfigAction';
const { StatusBarManager } = NativeModules;


const FlashMessageComp = ({messageConfig}) => {

    const { type = 'default', position="top", message, description, duration = 2000, ...restMessageConfig } = messageConfig;

    const getStyles = useCssStyle();
    const dispatch = useDispatch();

    const [statusBarHeight, setStatusBarHeight] = useState(0);


    const getStatusBarHeight = () => {
        if (Platform.OS === 'ios') {
            StatusBarManager.getHeight((height) => setStatusBarHeight(height.height || 0));
        } else {
            setStatusBarHeight(StatusBar.currentHeight || 0);
        }
    }


    useEffect(() => {
        getStatusBarHeight();

    }, [])


    useEffect(() => {

        if(duration){
            setTimeout(() => {
                dispatch(setRenderFlashMessage(false, {}))
            }, duration);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[duration])


    useEffect(() => {
        const flashMessageConfig = {
            type,
            position,
            icon: 'auto',
            message,
            description,
            autoHide:false,
            statusBarHeight,
            floating:true,
            style: getStyles(['flashMessageContainer', type == 'success' ? 'flashMessageContainerSuccess' : type == 'danger' ? 'flashMessageContainerError' : 'flashMessageContainerDefault']),
            textStyle: getStyles(['flashMessageContainer_text', type == 'success' ? 'flashMessageContainer_textSuccess' : type == 'danger' ? 'flashMessageContainer_textError' : 'flashMessageContainer_textDefault']),
            titleStyle:getStyles(['flashMessageContainer_title', type == 'success' ? 'flashMessageContainer_titleSuccess' : type == 'danger' ? 'flashMessageContainer_titleError' : 'flashMessageContainer_titleDefault']),
            ...restMessageConfig,
        };

        showMessage(flashMessageConfig);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusBarHeight]);

    return <FlashMessage />;
};

export default FlashMessageComp;